module.exports = __webpack_public_path__ + "img/S420.9b62bab2.jpg";